import moment from "moment";

export function installationFormValidateDates({ StartDate, StartTime }) {
    const date = StartDate + " " + StartTime;
    const start = moment(date, "DD/MM/YYYY hh:mm A");

    return start.diff(moment()) > 0;
}
